import React, { useEffect, useState } from "react";
import "./CourseQuestion.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {fetchData} from "../../../features/questions/questionSlice.js"
import MainLoader from "../../loaders/MainLoader.jsx";


function CourseQuestion({ questionSelected }) {
  
  const [selectedItemId, setSelectedItemId] = useState(null);
  
  const {  courseParam, difficulty, id } = useParams();

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch(fetchData({ course: `${courseParam}`, difficulty: `${difficulty}`, categories: 'programming' }));
  }, [dispatch, difficulty, courseParam]);

const response = useSelector((state) => state.questions.data)
const loading = useSelector((state) => state.questions.loading);
const error = useSelector((state) => state.questions.error);


useEffect(() => {
questionSelected(response?.[0])
// eslint-disable-next-line 
}, [response])

  const navigator = useNavigate();

  const handleCourseQuestionSelected = (itemId) => {
    setSelectedItemId(itemId);
    questionSelected(itemId);
    navigator(`/categories/${courseParam || itemId.courseName}/${difficulty || itemId.difficultyLevel}/${itemId._id}`);
  };

  useEffect(() => {
    dispatch(fetchData({ course: `${courseParam}`, difficulty: `${difficulty}`, categories: 'programming' }));
  }, [dispatch, courseParam, difficulty]);

  useEffect(() => {
    if (!id) {
      const firstQuestion = response && response.length > 0 ? response[0] : null;
      if (firstQuestion) {
        questionSelected(firstQuestion);
        navigator(`/categories/${courseParam ? courseParam.toLowerCase() : firstQuestion.courseName.toLowerCase()}/${difficulty ? difficulty.toLowerCase() : firstQuestion.difficultyLevel.toLowerCase()}/${firstQuestion._id}`);
      }
    } else {
      const selectedQuestion = response && response.length > 0 ? response.find((item) => item?._id === id) : null;
      if (selectedQuestion) {
        questionSelected(selectedQuestion);
        setSelectedItemId(selectedQuestion)
      }
    }
  }, [id, response, courseParam, difficulty, navigator, questionSelected]);



  return (
    <>
    {loading ? <MainLoader /> :
    <div
      className={`questionContainer w-full  overflow-scroll p-1 border border-gray-800 `}
    >
      {!error && response?.map((item, index) => (
        <ul key={index} className="questionsList w-full">
          <li
            tabIndex={0}
            className={`text-base mt-1 block w-full bg-gray-900 hover:bg-gray-950 cursor-pointer rounded p-3 overflow-x-hidden overflow-ellipsis whitespace-nowrap ${
              item?._id === selectedItemId?._id
                ? "bg-gray-700 border-b  border-gray-300"
                : ""
            }`}
            onClick={() => handleCourseQuestionSelected(item)}
          >
            {item?.questionText}
          </li>
        </ul>
      ))}
    </div>
  }
    </>

  );
  
}

export default CourseQuestion;
